<template>
  <div>
    <top-bar heading="File Browser" :buttons="buttons"></top-bar>
    <div class="container-fluid mt-3">
      <loading-spinner :loading="!fileTree.loaded"></loading-spinner>
      <b-card no-body v-show="fileTree.loaded">
        <b-card-header>
          File Browser
        </b-card-header>
        <b-card-body class="p-3">
          <div class="row">
            <div class="col-2 text-center mb-2" v-for="folder in fileTree.data" :key="'folder-' + folder.id">
              <div v-if="folder.type==='folder'">
                <span class="pointer" @click="loadFolder( folder.id )" @contextmenu.prevent="$refs.menu.open($event, { file: folder })">
                  <font-awesome-icon icon="folder-open" size="5x"></font-awesome-icon>
                  <br>
                  {{ folder.basename }}
                </span>
              </div>
              <div v-if="folder.type === 'file'" class="pointer" @click="openFile(folder)" @contextmenu.prevent="$refs.menu.open($event, { file: folder })">
                <span class="pointer" @click="openFile( folder )" @contextmenu.prevent="$refs.menu.open($event, { file: folder })">
                  <font-awesome-icon :icon="getIcon(folder.extension)" size="5x"></font-awesome-icon>
                  <br>
                  {{ folder.basename }}
                </span>
              </div>
            </div>
            <vue-context ref="menu">
              <ul class="p-0" slot-scope="child">
                <a :href="child.data.file.download" target="_blank" style="color: inherit;text-decoration: none;">
                  <li>
                    <font-awesome-icon icon="download"></font-awesome-icon>
                    Download
                  </li>
                </a>
              </ul>
            </vue-context>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash-es/debounce';
import Fuse from 'fuse.js';
import { VueContext } from 'vue-context';

export default {
  name: 'FileBrowser',
  data () {
    return {
      fileTree: {
        loaded: false,
        data: []
      },
      search: '',
      previous_folder: false,
      buttons: [
        {
          label: 'Home',
          click: () => {
            this.loadFolder(0);
          }
        },
        {
          label: 'Back',
          click: () => {
            this.loadFolder(this.previous_folder);
          }
        }
      ]
    };
  },
  methods: {
    loadFolder (folder_id) {

      if (!folder_id) {
        folder_id = 0;
      }

      this.previous_folder = this.$route.query.id || 0;

      this.$router.push('/tools/filebrowser?id=' + folder_id);

      this.fileTree.loaded = false;
      this.search = '';

      this.axios.get('/files', {params: {directory: folder_id}}).then(rsp => {
        this.fileTree.data = rsp.data;
        this.fileTree.loaded = true;
      });
    },
    // searchFiles: debounce(function (event) {
    //   const options = {
    //     shouldSort: true,
    //     //tokenize: true,
    //     //matchAllTokens: true,
    //     threshold: 0.6,
    //     //location: 0,
    //     distance: 50,
    //     maxPatternLength: 32,
    //     minMatchCharLength: 1,
    //     keys: [
    //       'basename',
    //       'path'
    //     ]
    //   };
    //   let fuse = new Fuse(this.fileTree.data, options); // "list" is the item array
    //   this.fileTree.data = fuse.search(event.target.value);
    // }, 500),
    getIcon (ext) {
      switch (ext) {
        case 'pdf':
          return 'file-pdf';
        case 'csv':
          return 'file-csv';
        case 'jpg':
        case'png':
          return 'file-image';
        default:
          return 'file';
      }
    },
    openFile (file) {
      const isImage = x => x === 'jpg' || x === 'png' || x === 'jpeg' || x === 'gif' || x === 'txt';
      const isPdf = x => x === 'pdf';
      if (isImage(file.extension)) {
        this.$modal.show({
          template: `
          <div>
            <img :src="url" class="img-fluid">
            <a :href="url" target="_blank" class="btn btn-primary btn-block rounded-0">Open</a>
          </div>
        `,
          props: ['url']
        }, {
          url: file.url
        }, {
          height: 'auto',
          //width: 'auto',
          adaptive: true
        }, {});
      } else if (isPdf(file.extension)) {
        this.$modal.show({
          template: `
          <div>
            <b-embed :src="url"></b-embed>
            <a :href="url" target="_blank" class="btn btn-primary btn-block rounded-0">Open</a>
          </div>
        `,
          props: ['url']
        }, {
          url: file.url
        }, {
          height: 'auto',
          //width: 'auto',
          adaptive: true
        }, {});
      } else {
        window.open(file.url, '_blank');
      }
    }
  },
  watch: {
    '$route.query.id' () {
      this.loadFolder(this.$route.query.id);
    }
  },
  components: {VueContext},
  mounted () {
    this.loadFolder(this.$route.query.id || 0);
  },
  metaInfo: {
    title: 'File Browser'
  }
};
</script>
